import React, { EventHandler, forwardRef } from 'react';
import styles from './MeritoButtons.module.scss';
import CircularLoader from '../CircularLoader/CircularLoader';
import { CircularProgress } from '@mui/material';


type Props = {
    type: "primary-1" | "secondary-1" | "secondary-2" | "tertiary" | "outline-dim" | "destructive-tint" | "destructive-ghost" | "inverse",
    children?: React.ReactNode,
    size?: "md" | "md2" | "sm" | "lg",
    icon?: React.ReactNode,
    btnText?: string | React.ReactNode;
    isIconToRight?: boolean;
    onClick?: (e: any) => void;
    btnType?: "button" | "submit" | "reset";
    loading?: boolean;
    isRounded?: boolean;
    disabled?: boolean;
    hover?: boolean;
    showLoadingWithText?: boolean;
    onlyIcon?: boolean;
    onBlur?: (e) => void;
    appendChild?: boolean;
    isNotification?: boolean; // Passing this true will lead to have an red dot in right corner of the button
    extraStyles?: React.CSSProperties
    className?: string;
}

const MeritoButton = forwardRef(({ type, onBlur = () => { }, isRounded = false, children = null, size = "md", icon = null, btnText, isIconToRight = false, onClick = () => { }, btnType = "button", loading, disabled = false, hover = true, showLoadingWithText = false, onlyIcon = false, appendChild = false, isNotification = false, extraStyles = {}, className = "", }: Props, ref: any) => {


    return (
        <button ref={ref} onBlur={onBlur} type={btnType} disabled={disabled} onClick={onClick} className={`${styles[type]} ${styles[size]}  ${loading && !showLoadingWithText ? styles.loading : ''} ${isRounded ? styles.rounded : ''} ${hover ? styles.enableHover : ''} ${onlyIcon ? styles.onlyIcon : ''} ${className}`} style={extraStyles}>
            {(children && !appendChild) ? children :
                <div className={`${styles.btnContainer} ${isIconToRight ? styles.reverse : ''}`}>
                    {showLoadingWithText && loading ? <div style={{ display: "flex" }}>
                        <CircularProgress style={type == "secondary-1" || type == "secondary-2" || type == "outline-dim" ? { color: "#100828" } : { color: "#ffff" }} size={"1rem"} thickness={4} />
                    </div> : icon ? <div className={styles.iconContainer}>
                        {icon}
                    </div> : null}
                    {btnText ? <div className={styles.btnText}>
                        {btnText}
                    </div> : null}
                    {children && appendChild ? children : null}
                    {isNotification ? <div className={styles.notificationDot}></div> : null}
                </div>}
        </button>
    );
});

export default MeritoButton;